import Tooltip from "~/components/Tooltip";
import {
	invoiceStatusFilterButtonVariants,
} from "~/modules/billing/components/InvoicesIndexView/components/InvoiceStatusButtonFilter/invoiceStatusFilterButtonVariants.ts";

import type { QuotaListStatus } from "../quotasIndexTableTypes.ts";
import { getQuotaStatusDisplayName, getQuotaStatusIcon, quotaListStatuses } from "../quotasIndexUtils.tsx";

type Props = {
	filterValues: QuotaListStatus[];
	onChange: (newStatusFilter: QuotaListStatus[]) => void;
};

const QuotaStatusButtonFilter = ({ filterValues, onChange }: Props) => {
	const handleOnChange = (status: QuotaListStatus) => {
		if (filterValues.includes(status)) {
			onChange(filterValues.filter(value => value !== status));
		} else {
			onChange([...filterValues, status]);
		}
	};

	return (
		<div className="flex flex-row">
			{quotaListStatuses.map((status) => {
				const checked = filterValues.includes(status);
				const { button } = invoiceStatusFilterButtonVariants({ checked, size: "sm" });
				return (
					<Tooltip key={"status-" + status}
							 text={getQuotaStatusDisplayName(status)}>
						<label className={button()}
							   tabIndex={0}>
							{getQuotaStatusIcon(status, `size-5 ${!checked ? "opacity-40" : ""}`)}
							<input className="hidden"
								   type="checkbox"
								   checked={checked}
								   onChange={() => handleOnChange(status)} />
						</label>
					</Tooltip>
				);
			})}
		</div>
	);
};

export default QuotaStatusButtonFilter;
